import MainPageLayout from 'layouts/MainPageLayout';
import PostcardWidget from './Postcard/PostcardWidget';
import { PostcardContextProvider } from 'contexts/Communicate/Postcard/PostcardContext';
import { FormattedMessage } from 'react-intl';

const PostcardPure = (): JSX.Element => (
  <MainPageLayout title={<FormattedMessage id="postcard.description" />}>
    <PostcardWidget />
  </MainPageLayout>
);

const Postcard = (): JSX.Element => {
  return (
    <PostcardContextProvider>
      <PostcardPure />
    </PostcardContextProvider>
  );
};

export default Postcard;
